import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { findMatch } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import {
  fetchSubscriptionsError,
  fetchSubscriptionsSuccess,
  toggleSubscribeError,
  toggleSubscribeSuccess,
  toggleUnsubscribeSuccess,
} from '../actions';
import subscriptionActions from '../constants';
import SubscriptionsService from '../service';

export function* fetchSubscription() {
  const { response, error } = yield call(callAdapter, SubscriptionsService.getSubscriptions());

  if (error) {
    yield put(fetchSubscriptionsError(error));
  } else {
    yield put(fetchSubscriptionsSuccess(response));
  }
}

export function* toggleSubscription({ event }) {
  const subscriptions = yield select(selectors.subscriptions);
  const isSubscribed = !!findMatch(subscriptions?.results, event, 'event');

  const { response, error } = yield call(callAdapter, isSubscribed
    ? SubscriptionsService.unsubscribe(event) : SubscriptionsService.subscribe(event));

  if (error) {
    yield put(toggleSubscribeError(event, error));
  } else {
    yield put(isSubscribed ? toggleUnsubscribeSuccess(event, response) : toggleSubscribeSuccess(event, response));
  }
}

export default function* subscriptionsApi() {
  yield takeEvery(subscriptionActions.FETCH_SUBSCRIPTIONS, fetchSubscription);
  yield takeEvery(subscriptionActions.TOGGLE_SUBSCRIPTION, toggleSubscription);
}
